// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles_logo__2SJXT","collapsed":"styles_collapsed__1irEO","full":"styles_full__Apuvu"};